String.prototype.hashCode = function () {
  let hash = 0;
  if (this.length == 0) {
    return hash;
  }
  for (let i = 0; i < this.length; i++) {
    const char = this.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

String.prototype.toNumber = function (p?: number) {
  p = p || 10;
  return parseFloat(parseFloat(this).toFixed(p));
};
